<template>
  <div class="ruKuZuoyeWarp app-container">
    <div class="ruKuZuoyeWarp-body">
      <div >
        <!-- 查询条件 -->
        <div ref="searchBox" class="formBox margbot">
          <el-form :inline="true" :model="formData" class="demo-form-inline" label-width="110px" size="mini">
            <div class="formItemBox">
            <el-form-item label="入库单号:">
              <el-input
                v-model="formData.instockNo"
                placeholder="请输入库单号"
                size="mini"
              ></el-input>
            </el-form-item>
            <el-form-item label="一级货主:">
              <el-select
                v-model="formData.primaryCustomerTaxId"
                size="mini"
                placeholder="请选择货主"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in RKData"
                  :key="index"
                  :label="item.custerName"
                  :value="item.taxpayerNumber"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级货主:">
              <el-select
                v-model="formData.customerTaxId"
                size="mini"
                placeholder="请选择货主"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in RKData"
                  :key="index"
                  :label="item.custerName"
                  :value="item.taxpayerNumber"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="入库日期:">
              <div style="display: flex;">
              <el-date-picker
                v-model="formData.instockDateStart"
                size="mini"
                type="datetime"
                placeholder="选择入库日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
              -
              <el-date-picker
                v-model="formData.instockDateEnd"
                size="mini"
                placeholder="选择入库日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
              ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="车号:">
              <el-input
                class="ipt"
                v-model="formData.instockPlateNumber"
                placeholder="请输入车号"
                size="mini"
                maxlength="10"
              ></el-input>
            </el-form-item>
             <el-form-item label="到货方式:">
              <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
              <el-option
                v-for="(item, index) in arrivalMethodData"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
              </el-select>
            </el-form-item>
           </div>
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP002B001" v-if="btnFlg[0]">查询</el-button>
              <el-button type="primary" class="button" size="mini" @click="chongZhi" btnCode="00cP002B002" v-if="btnFlg[1]">重置</el-button>
              <el-button type="primary" class="button" size="mini" @click="daYin" btnCode="00cP002B003" v-if="btnFlg[2]">打印入库单</el-button>
              <el-button type="primary" class="button" size="mini" @click="daochu" btnCode="00cP002B004" v-if="btnFlg[3]">导出</el-button>
              <el-button type="primary" class="button" size="mini" @click="daoru" btnCode="00cP002B005" v-if="btnFlg[4]">导入</el-button>
              <el-button type="primary" class="button" size="mini" @click="xiazai" btnCode="00cP002B006" v-if="btnFlg[5]">下载模板</el-button>
            </el-form-item>
            <el-form-item>
               <span style="margin-left:10px;">总吨数：<span style="color: red">{{ totalTon }}</span>吨</span>
              <span style="margin-left:10px;">总件数：<span style="color: red">{{ totalNum }}</span>件</span>
            </el-form-item>
          </el-form>

        </div>
        <!-- 表格 -->
        <div :style="{ height: h }">
          <el-table
          height="100%"
          size="mini"
          ref="tabref1"
          :data="tableData"
          style="width: 100%"
          class="tableComent"
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          highlight-current-row
          @row-click="dianjixuanzhong"
          border
          center
          bordersize="mini"
          >
            <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
            <el-table-column align="center" label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text"  @click="lookImg(scope.row)" size="mini">查看单据</el-button>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center" width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库人" align="center" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库时间" align="center" width="180" :formatter="dateTimeFormat"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="入库车牌号" align="center" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机姓名" align="center" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center" width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center" width="150"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="130"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车船号" align="center" width="130"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="shipForecastNo" label="预报编号" align="center" width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" width="180" :formatter="dateTimeFormat"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="ext1" label="备注" align="center" width="150"></el-table-column>
          </el-table>
          </div>
          <!--分页-->
          <div class="pags" style="text-align: right">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="pageInfo.pageNo"
              :page-size="pageInfo.pageSize"
              :page-sizes="[10, 20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              :total="total"
            ></el-pagination>
          </div>
          <!--货物详情-->
          <div style="margin-top:8px;">
             <div class="detailsTitle">
              <h4>货物详情</h4>
            </div>
            <div ref="searchBox2" style="margin-top: 5px;margin-left:10px;">
              <span>
                总吨数:
                <span style="color: red">{{ allWeight }}</span> &nbsp;吨
              </span>
              <span style="margin-left: 15px">
                总件数:
                <span style="color: red">{{ allnumber }}</span> &nbsp;件
              </span>
            </div>
            <!--详情表格-->
            <div class="ruKuZuoyeWarp-body-detailsTab">
              <div class="ruKuZuoyeWarp-body-table" :style="{ height: detailsH }">
                <el-table
                  height="100%"
                  size="mini"
                  ref="tabref"
                  :data="detailsData"
                  style="width: 100%"
                  :header-cell-style="{
                    background: '#F5F5F5',
                    color: 'black',
                  }"
                  highlight-current-row
                  @row-click="dianjixuanzhongdown"
                  border
                  center
                  bordersize="mini"
                >
                  <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                  <el-table-column align="center" label="操作" width="80">
                    <template slot-scope="scope">
                      <el-button type="text"  @click="guoBangClick(scope.row)" size="mini">过磅记录</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width=""></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width=""></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width=""></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width=""></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="singletonWeight" label="单件理重（吨）" align="center" width=""></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width=""></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" width=""></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" width=""></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重(吨)" align="center" width=""></el-table-column>
                  <!-- <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="实际过磅时间" align="center" width="180" :formatter="dateTimeFormat"></el-table-column> -->
                  <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" align="center" width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center" width=""></el-table-column>
                  <!-- <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" align="center" width="150"></el-table-column> -->
                </el-table>
              </div>
              <!--分页-->
              <div class="pags" style="text-align: right">
                <el-pagination
                  background
                  @current-change="handleCurrentChangeXQ"
                  :current-page="pageInfoXQ.pageNo"
                  :page-size="pageInfoXQ.pageSize"
                  :page-sizes="[10, 20, 30, 40, 50]"
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChangeXQ"
                  :total="totalXQ"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!--点击导入按钮弹出框-->
      <div class="addMarkBox" custom-class="el-dialog--center">
        <el-dialog
          @close="closeDialogFile"
          title="导入"
          :visible.sync="daoruMark"
          :close-on-click-modal="false"
          width="40%"
          center
        >
          <div style="margin: 15px auto" class="el-dialog--center">
            <input
              type="file"
              ref="file"
              accept=".xls, .csv, .xlsx"
              @change="getFile($event)"
            />
          </div>
          <div style="margin: 15px auto" class="el-dialog--center">
            <el-button @click="daoruMark = false">取消</el-button>
            <el-button type="primary" @click="daoruQueding()" :disabled="isDisable1">确定</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 查看单据 -->
    <dj-dialog v-if="CKDJVisible" :CKDJVisible.sync='CKDJVisible' :instockId="instockId"></dj-dialog>
    <!-- 过磅记录 -->
    <gBJiLu-dialog v-if="guoBangVisible" :guoBangVisible.sync='guoBangVisible' :instockSummaryId="instockSummaryId"></gBJiLu-dialog>
  </div>
</template>

<script>
import {
  JfgetThreadExpList,
  JfgetThreadDetailExpList,
  JfgetThreadDetailExpWN,
  JfgetThreadExpWeightp,
  importInstockBill
} from '@/api/wms-access'

import { getRelationCustomer } from '@/api/wms-stock'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateTimeFormat, dateFormat1 } from '@/utils/util'
import gBJiLuDialog from '../gBJiLuDialog.vue'
import { exportExcel } from '@/utils/fileDown.js'
import djDialog from '../yycChuanYun/dialog/DJindex.vue'
export default {
  components: { djDialog, gBJiLuDialog },
  data () {
    return {
      formData: {
        instockNo: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        instockPlateNumber: '',
        instockDateEnd: dateFormat1(new Date().getTime(), 'YYYY-MM-ss h-m-s'),
        instockDateStart: dateFormat1(new Date().getTime() - 1000 * 60 * 60 * 24 * 15, 'YYYY-MM-ss h-m-s'),
        arrivalMethod: ''
      },
      RKData: [],
      btnFlg: [],
      tableData: [],
      allWeight: '0',
      allnumber: '0',
      btnIdArr: [
        '00cP002B001',
        '00cP002B002',
        '00cP002B003',
        '00cP002B004',
        '00cP002B005',
        '00cP002B006'
      ],
      detailsH: '200px',
      h: '200px',
      detailsData: [], // 详情数据
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      pageInfoXQ: {
        pageSize: 20,
        pageNo: 1
      },
      currentXQ: 1,
      total: 0,
      totalXQ: 0,
      xuanzhongArr: null,
      xuanzhongArrdown: null,
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      totalTon: 0, // 主表总吨数
      totalNum: 0, // 主表总件数
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      // 查看单据
      CKDJVisible: false,
      instockId: '',
      guoBangVisible: false,
      instockSummaryId: '',
      daoruMark: false,
      isDisable1: false
    }
  },
  methods: {
    // 下载模板
    xiazai () {
      window.open(
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/wms/ExcelModel/%E5%85%A5%E5%BA%93%E5%8D%95%E6%8D%AE%E5%AF%BC%E5%85%A5(%E7%B2%A4%E8%BF%90%E4%BB%93).xlsx'
      )
    },
    // 点击过磅记录
    guoBangClick (row) {
      this.guoBangVisible = true
      this.instockSummaryId = row.instockSummaryId
    },
    // 查看单据
    lookImg (row) {
      this.CKDJVisible = true
      this.instockId = row.instockId
    },
    JfgetThreadExpWeightp () {
      JfgetThreadExpWeightp(
        {
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          instockNo: this.formData.instockNo,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          instockPlateNumber: this.formData.instockPlateNumber,
          instockStatus: 1,
          instockDateStart: this.formData.instockDateStart,
          instockDateEnd: this.formData.instockDateEnd,
          arrivalMethod: this.formData.arrivalMethod
        }
      )
        .then(res => {
          this.totalTon = res.totalAllWeight
          this.totalNum = res.totalAllNumber
        })
        .catch(err => {
          this.message({ message: err.message, type: 'error' })
        })
    },
    daochu () {
      exportExcel(
        this.global.wmsAccessName + '/instockThread/exportInThreadMasterList',
        { ...this.formData, instockStatus: '1' },
        '入库单据表'
      )
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.JfgetThreadDetailExpLists()
    },
    dianjixuanzhongdown (row) {
      this.xuanzhongArrdown = {}
      this.xuanzhongArrdown = row
    },
    chaxun () {
      this.JfgetThreadExpLists()
    },
    chongZhi () {
      this.formData.instockNo = ''
      this.formData.customerTaxId = ''
      this.formData.primaryCustomerTaxId = ''
      this.formData.instockPlateNumber = ''
      this.formData.instockDateStart = ''
      this.formData.instockDateEnd = ''
      this.formData.arrivalMethod = ''
      this.JfgetThreadExpLists()
    },
    daYin () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error' }
        )
        return
      }
      this.$router.push({
        path: '/yycRuKuDan',
        query: {
          id: this.xuanzhongArr.instockId
        }
      })
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetThreadExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetThreadExpLists()
    },
    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.JfgetThreadDetailExpLists()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.JfgetThreadDetailExpLists()
    },
    // 主列表显示
    JfgetThreadExpLists () {
      JfgetThreadExpList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instockNo: this.formData.instockNo,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        instockPlateNumber: this.formData.instockPlateNumber,
        instockStatus: 1,
        instockDateStart: this.formData.instockDateStart,
        instockDateEnd: this.formData.instockDateEnd,
        arrivalMethod: this.formData.arrivalMethod
      })
        .then(res => {
          this.tableData = res.list
          if (res.list.length > 0) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => { this.$refs.tabref1.setCurrentRow(res.list[0]) })
            this.JfgetThreadDetailExpLists()
            this.JfgetThreadExpWeightp()
          } else {
            this.detailsData = []
            this.allWeight = 0
            this.allnumber = 0
            this.totalXQ = 0
            this.totalTon = 0
            this.totalNum = 0
          }
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error)
        })
    },
    // 货物详情
    JfgetThreadDetailExpLists () {
      JfgetThreadDetailExpList({
        instockId: this.xuanzhongArr.instockId,
        ...this.pageInfoXQ
      })
        .then(res => {
          this.detailsData = res.list
          this.xuanzhongArrdown = res.list[0]
          this.$nextTick(() => { this.$refs.tabref.setCurrentRow(res.list[0]) })
          this.totalXQ = res.total

          this.JfgetThreadDetailExpWNs()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 总重量
    JfgetThreadDetailExpWNs () {
      JfgetThreadDetailExpWN({
        instockId: this.xuanzhongArr.instockId
      })
        .then(res => {
          this.allWeight = res.totalAllWeight
          this.allnumber = res.totalNumber
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    daoru () {
      this.daoruMark = true
      this.file = []
    },
    closeDialogFile () {
      this.$refs.file.value = ''
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    // 导入-确定
    daoruQueding (event) {
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        }
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      let name = extname(this.file.name)
      if (name == false) {
        this.$alert('文件为空,请选择文件进行导入', '系统提示')
      } else if (name != 'xlsx' && name != 'csv' && name != 'xls') {
        this.$alert('请选择正确的文件格式', '系统提示')
      } else {
        let formData = new FormData()
        formData.append('file', this.file)
        this.isDisable1 = true
        importInstockBill(formData)
          .then((res) => {
            // -1 提示错误信息， 0 成功， 1显示导出异常
            this.daoruMark = false
            this.isDisable1 = false
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.chaxun()
          })
          .catch((err) => {
            if (err.code == -1) {
              this.$message({
                message: err.data == null ? err.message : err.data,
                type: 'error'
              })
            }
            this.isDisable1 = false
          })
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yycRkDan')
    this.getRelationCustomerS()
    this.JfgetThreadExpLists()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 175 + 'px'
    this.detailsH = 0.4 * pH - h2 - 80 + 'px'
  }
}
</script>

<style lang="less" scoped>
.inpBox{
  .el-form-item{
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.ruKuZuoyeWarp {
  width: 100%;
  position: relative;
}
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
